<template lang="html">
  <scrollable-content>
    <template>
      <div id="availability-keyplans"
      class="m-auto">
        <img :src="getKP" />
        <!-- <keyplan v-for="(keyplan, index) in keyplansByFloor"
        :key="keyplan.data.id + '_' + keyplan.floor + '_' + index"
        :id="keyplan.data.id"
        :nodeData="keyplan.data"
        :floor="keyplan.floor"
        :displayChanged="active"
        :class="keyplanClass(keyplan.floor)"
        @selectedUnit="selectedUnit()"
        /> -->
      </div>
    </template>
  </scrollable-content>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import VueScrollTo from 'vue-scrollto';
import ScrollableContentComponent from '@/components/ScrollableContent';
import AvailabilityKeyplan from './AvailabilityKeyplan';

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortOrder: 'asc',
      unitListScrolling: false,
      scrollFunction: null
    };
  },
  computed: {
    ...mapState({
      keyplanList: state => state.floorplans.availability.keyplanList,
      selectedUnitName: state => state.floorplans.selectedUnitName,
      assetsUrl: state => state.project.assetsUrl
    }),
    ...mapGetters({
      getFloorplanById: 'floorplans/getFloorplanById',
    }),
    keyplansByFloor() {
      const keyplanListByFloor = [];
      this.keyplanList.forEach((keyplan) => {
        const floors = keyplan.floors.split(',');
        floors.forEach((floor) => {
          keyplanListByFloor.push({ floor, data: keyplan });
        });
      });

      if (this.sortOrder === 'dsc') {
        keyplanListByFloor.sort((a, b) => parseInt(b.floor, 10) - parseInt(a.floor, 10));
      } else {
        keyplanListByFloor.sort((a, b) => parseInt(a.floor, 10) - parseInt(b.floor, 10));
      }
      return keyplanListByFloor;
    },
    getKP() {
      if (this.$route.name === 'FloorplanDetail') {
        try {
          return this.assetsUrl + this.floorplan.current.assets.keyplan.url;
        } catch (e) {
          return '';
        }
      }
      return '';
    },
    floorplan() {
      let fp = null;
      if (this.$route.name === 'FloorplanDetail') {
        fp = this.getFloorplanById(this.$route.params.id);
        if (!fp.current) {
          this.setShowFavourites(false);
          fp = this.getFloorplanById(this.$route.params.id);
        }
      }
      return fp;
    },
  },
  methods: {
    ...mapMutations({
      setShowFavourites: 'floorplans/setShowFavourites',
    }),
    keyplanClass(floor) {
      let floorText = floor;
      if (floor.length === 1) {
        floorText = `0${floorText}`;
      }
      return `kp-floor-${floorText}`;
    },
    scrollToSelectedFloor() {
      if (this.scrollFunction) this.scrollFunction();
      const selectedFloorClass = `.kp-floor-${this.selectedUnitName.substr(0, 2)}`;
      this.scrollFunction = VueScrollTo.scrollTo(selectedFloorClass, 500, {
        container: '#availability-content .scrollable-content-content',
        offset: -300
      });
    },
    selectedUnit() {
      this.unitListScrolling = true;
    }
  },
  watch: {
    selectedUnitName() {
      if (this.active) {
        if (!this.unitListScrolling && this.selectedUnitName) {
          this.scrollToSelectedFloor();
        } else {
          this.unitListScrolling = false;
        }
      }
    }
  },
  components: {
    'scrollable-content': ScrollableContentComponent,
    keyplan: AvailabilityKeyplan
  }
};
</script>

<style lang="scss" scoped>
#availability-keyplans {
  @media screen and (max-width: $breakpoint-sm)
  {
    img {
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/Availability/AvailabilityKeyplans.vue